import * as urls from "../../api/C4S Decommission - Replacement/url";
import { postRequest } from "../../../services/RestServices";

export const addReturnItem = async (payload) => {
  try {
    return await postRequest(urls.ADD_RETURN_ITEMS, payload);
  } catch (err) {
    return err;
  }
};
